<template>
    <component
        class="sidebar-item"
        :class="{ 'sidebar-item_disabled': disabled }"
        tag="li"
        :is="currentComponent"
        :to="dataLink"
        :href="dataLink"
        :disabled="disabled"
        active-class="active"
        @click.native="emitLinkClick"
        @click="emitLiClick"
    >
        <span class="bar">&nbsp;</span>

        <div class="content" :style="dataStyle">
            <span
                v-if="dataIcon && !isCompiledIcon"
                class="mdi"
                :class="dataIcon"
            ></span>
            <svgicon
                v-else-if="dataIcon && isCompiledIcon"
                :icon="dataIcon"
                width="18"
                height="18"
            ></svgicon>
            <span class="item-name">{{ dataTitle }}</span>
        </div>
    </component>
</template>

<script>
export default {
    props: {
        dataTitle: {
            type: String,
            required: true,
        },
        dataLink: {
            type: String,
            required: false,
        },
        dataIcon: {
            type: String,
            required: false,
        },
        dataStyle: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isCompiledIcon: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        currentComponent() {
            return this.dataLink && !this.disabled
                ? this.dataLink.startsWith("http")
                    ? "a"
                    : "router-link"
                : "li";
        },
    },

    methods: {
        emitLinkClick(event) {
            if (this.disabled) {
                event.stopImmediatePropagation();
                return;
            }

            if (this.dataLink) {
                event.stopImmediatePropagation();

                this.$emit("click");
            }
        },
        emitLiClick(event) {
            if (this.disabled) {
                event.stopImmediatePropagation();
                return;
            }

            if (!this.dataLink) {
                event.stopImmediatePropagation();

                this.$emit("click");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.sidebar-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 5px 0;
    color: $grey-4;
    font-size: 14px;

    .content {
        display: flex;
        align-items: center;
        margin-left: 35px;

        .mdi,
        svg {
            font-size: 18px;
            margin-right: 7px;
        }

        svg {
            fill: $grey-4;
        }
    }

    .bar {
        height: 42px;
        width: 5px;
        background-color: transparent;
    }

    &.active {
        color: $green-dark;

        .bar {
            background-color: $green;
        }
    }

    &:hover {
        color: $green-dark;

        svg {
            fill: $green-dark;
        }
    }

    &.sidebar-item_disabled {
        cursor: not-allowed;
        opacity: 0.5;

        &:hover {
            color: $grey-4;
        }
    }
}
</style>
